import { useEffect } from "react";
import FileCarousel from "../components/FileCarousel";
import FeaturedProductList from "../components/FeaturedProductList";
import { useSelectedLocation } from "../contexts/SelectedLocationContext";
import { HomePageCarouselImages } from "../data/CarouselFiles";
import PageSection from "../components/PageSection";
import MediaFooter from "../components/MediaFooter";
import { Tab } from "../types/Tab";
import PageContainer from "../components/PageContainer";
import { useDocumentMeta } from "../hooks/useDocumentMeta";

const HomePage = () => {
  const { setDomain, setCategory, setProduct } = useSelectedLocation();
  useDocumentMeta({
    description:
      "Shop classic Americana clothing and lifestyle goods. Printed in the USA, timeless style.",
    path: "/",
  });
  useEffect(() => {
    setDomain(Tab.Home.toString());
    setCategory(null);
    setProduct(null);
  }, [setDomain, setCategory, setProduct]);

  return (
    <>
      <PageContainer>
        <PageSection isPadded={false} className="carousel bg-[#f0e4d7]">
          <FileCarousel files={HomePageCarouselImages} interval={5000} />
        </PageSection>
        <PageSection className="flex flex-col">
          <FeaturedProductList />
        </PageSection>
        <PageSection isPadded={false} className="page-container-full-image">
          <div className="relative w-full" style={{ minHeight: "inherit" }}>
            <img
              src={"/images/buffalo-material.png"}
              alt={`Buffalo Material`}
              className="w-full h-full object-cover"
              style={{ minHeight: "50vh", maxHeight: "75vh" }}
            />
            <img
              src="/images/buffalo-overlay.png"
              alt="Buffalo Overlay"
              className="absolute inset-0 w-full h-full object-contain pointer-events-none"
            />
          </div>
        </PageSection>
        <PageSection isPadded={false} className="page-container-full-image">
          <img
            src={"/images/main-design-murica.png"}
            alt={`Main Design Murica`}
            className="w-full object-cover"
            style={{ minHeight: "50vh", maxHeight: "75vh" }}
          />
        </PageSection>
      </PageContainer>
      <MediaFooter />
    </>
  );
};

export default HomePage;
